import { apiGet } from 'utils/request';
import HOST from 'utils/globals';

export const fetchUserProfile = () => apiGet(`${HOST}/users/me`);
